import { Icon } from "@brexhq/metal-icon";
import styled from "@emotion/styled";
import React from "react";

import { BlockRows } from "@brexhq/next/src/components/shared/BlockRows/BlockRows";
import { ModuleThemeType } from "@brexhq/shared/types/ModuleTheme";
import { SanityCreditCardBlockProps } from "@brexhq/shared/types/modules/BlockRowsModule/BlockRowItems";

type CreditCardBlockAccordionProps = Pick<
  SanityCreditCardBlockProps,
  "accordion"
> & {
  theme?: ModuleThemeType;
};

const AccordionWrapper = styled.div(({ theme }) => ({
  padding: theme.spacing[24],
  borderTop: `1px solid ${theme.colors.border.default}`,
  [theme.breakpoints.phone]: {
    padding: theme.spacing[16],
  },
}));

const Details = styled.details(({ theme }) => ({
  "& summary": {
    listStyle: "none",
    cursor: "pointer",
    paddingTop: theme.spacing[16],
    paddingBottom: theme.spacing[16],
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    "&::-webkit-details-marker": {
      display: "none",
    },
    "&::marker": {
      display: "none",
    },
    fontWeight: 600,
    fontSize: 14,
  },
  "&:not(:last-child)": {
    borderBottom: `1px solid ${theme.colors.border.default}`,
  },
  "&[open]": {
    paddingBottom: theme.spacing[16],
  },
}));

const ChevronIcon = styled(Icon)(({ theme }) => ({
  transition: "transform .15s ease-in-out",
  color: theme.colors.content.secondary,
  "details[open] &": {
    transform: "rotate(180deg)",
  },
}));

export const CreditCardBlockAccordion = ({
  accordion,
  theme = "PrimaryWhite",
}: CreditCardBlockAccordionProps) => {
  if (!Array.isArray(accordion) || accordion.length === 0) return null;

  return (
    <AccordionWrapper>
      {accordion.map((item, index) => (
        // eslint-disable-next-line react/no-array-index-key
        <Details key={`${item.header}-${index}`}>
          <summary>
            <span>{item.header}</span>
            <ChevronIcon size={16} name="chevronDown" />
          </summary>
          {item.textRows && (
            <BlockRows
              rows={item.textRows.textRows}
              theme={theme}
              alignment="left"
            />
          )}
        </Details>
      ))}
    </AccordionWrapper>
  );
};
